// Fetch wrapper to decorate the Load Failed error with the resource that caused it
// so that we can have a sliver of a chance to debug it
const ANALYTICS_HOSTS = ['google-analytics.com', 'google.com/g/collect']

export function startFetchWrapper() {
  const originalFetch = window.fetch
  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    return originalFetch(input, init).catch((error: TypeError) => {
      if (error instanceof TypeError) {
        const stringResource = String(input)
        // Analytics requests commonly fail due to ad blockers - don't surface as errors
        if (ANALYTICS_HOSTS.some((host) => stringResource.includes(host)))
          return new Response(null, { status: 0 })
        // decorate the error with the resource that caused it
        error.message = `${error.message} (${stringResource})`
      }
      throw error
    })
  }
}
